declare namespace $ {

	export class $mol_icon_archive extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=archive.view.tree.d.ts.map